<template>
  <div class="wlx-stu-basic-wrapper">
    <el-tabs tab-position="top" style="height: auto" v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="全部考证活动" name="first">
        <allStuCerfityInfo v-if="tabName=='first'"></allStuCerfityInfo>
      </el-tab-pane>
      <el-tab-pane label="我报名的活动" name="second">
        <mySignUpActivity v-if="tabName=='second'"></mySignUpActivity>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
import allStuCerfityInfo from "page/xSchool/stuManager/allStuCerfityInfo.vue";
import mySignUpActivity from "page/xSchool/stuManager/mySignUpActivity.vue";
export default {
  data() {
    return {
      tabName: "first"
    };
  },
  components: {
    allStuCerfityInfo,
    mySignUpActivity
  },
  created() {
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.wlx-stu-basic-wrapper{
  .el-tabs__header {
        position: fixed;
        top: 60px;
        right: 0;
        height: 60px;
        width: calc(100% - 240px);
        z-index: 1000;
        background: #fff;
        text-align: right;
    }
    .el-tabs__item {
        width: 140px;
        text-align: center;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
    }
    .el-tabs__content {
        margin: 80px 0 0 30px;
        background: #fff;
        .el-tab-pane {
            padding: 20px;
        }
    }
}
</style>
